import React from 'react';
import ProgressBar from 'Components/ProgressBar';

const useComponent = () => {
  const thereIsComponent = (data, index) => {
    if (index === 4) {
      const values = data[index].split('/');
      const percentage = (values[0] / values[1]) * 100;
      let value = percentage;
      const coursesComplete = values[0];
      const totslCourses = values[1];
      if (coursesComplete === '0' && totslCourses === '0') {
        value = 0;
      }
      return (
        <div>
          <div>{data[index]}</div>
          <ProgressBar value={value} />
        </div>
      );
    }

    return data[index];
  };

  return {
    thereIsComponent,
  };
};

export default useComponent;
